import React from 'react';
import type { MenuItem, Category, QuickAddCombo, Recipe, InventoryItem, BuffetPackage } from '../../types';
import MenuManagementPage from '../../pages/MenuManagementPage';

interface PosMenuManagementOverlayProps {
  onClose: () => void;
  menuItems: MenuItem[];
  categories: Category[];
  quickAddCombos: QuickAddCombo[];
  recipes: Recipe[];
  inventoryItems: InventoryItem[];
  recipeInventoryMode: 'inventory_connected' | 'cost_only';
  buffetPackages: BuffetPackage[];
  onSaveBuffetPackages: (packages: BuffetPackage[]) => Promise<void> | void;
  onSave: (item: MenuItem) => void;
  onDelete: (itemId: number) => void;
  onSaveCategory: (category: Category) => void;
  onDeleteCategory: (categoryId: number | string) => void;
  onBulkAddMenuItems: (items: any[]) => Promise<{ successCount: number; failedItems: string[] }>;
  onSaveCombo: (combo: Omit<QuickAddCombo, 'id'> | QuickAddCombo) => Promise<void>;
  onDeleteCombo: (comboId: number) => Promise<void>;
  onSaveRecipe: (recipe: Recipe) => void;
}

const PosMenuManagementOverlay: React.FC<PosMenuManagementOverlayProps> = ({
  onClose,
  menuItems,
  categories,
  quickAddCombos,
  recipes,
  inventoryItems,
  recipeInventoryMode,
  buffetPackages,
  onSaveBuffetPackages,
  onSave,
  onDelete,
  onSaveCategory,
  onDeleteCategory,
  onBulkAddMenuItems,
  onSaveCombo,
  onDeleteCombo,
  onSaveRecipe,
}) => {
  return (
    <div className="fixed inset-0 z-[80] flex flex-col bg-white">
      <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-gray-200 bg-white shrink-0 shadow-sm">
        <h2 className="text-lg font-bold text-gray-900">Menu Management</h2>
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-sm font-bold rounded-md bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors"
        >
          Close
        </button>
      </div>
      <div className="flex-1 min-h-0 overflow-auto">
        <MenuManagementPage
          menuItems={menuItems}
          categories={categories}
          quickAddCombos={quickAddCombos}
          recipes={recipes}
          inventoryItems={inventoryItems}
          recipeInventoryMode={recipeInventoryMode}
          buffetPackages={buffetPackages}
          onSaveBuffetPackages={onSaveBuffetPackages}
          onSave={onSave}
          onDelete={onDelete}
          onSaveCategory={onSaveCategory}
          onDeleteCategory={onDeleteCategory}
          onBulkAddMenuItems={onBulkAddMenuItems}
          onSaveCombo={onSaveCombo}
          onDeleteCombo={onDeleteCombo}
          onSaveRecipe={onSaveRecipe}
        />
      </div>
    </div>
  );
};

export default PosMenuManagementOverlay;
